import { LDSingleKindContext } from 'launchdarkly-js-sdk-common';
import { User } from '@trucksmarter/shared';

type LaunchDarklyAuthenticatedUser = Pick<
  User,
  'id' | 'email' | 'name' | 'phoneNumber' | 'role'
>;

export type LaunchDarklyUser =
  | LaunchDarklyAuthenticatedUser
  | { type: 'anonymous'; key?: string };

type LDSingleKindContextWithKey = LDSingleKindContext & { key: string };

const PLATFORM_NAME = 'web';

export const toLaunchDarklyContext = (
  user: LaunchDarklyUser,
): LDSingleKindContextWithKey =>
  'type' in user
    ? {
        kind: 'user',
        key: user.key || 'unidentified_user',
        anonymous: true,
        platform: PLATFORM_NAME,
      }
    : {
        kind: 'user',
        key: user.id,
        email: user.email,
        name: user.name,
        anonymous: false,
        phoneNumber: user.phoneNumber,
        role: user.role,
        platform: PLATFORM_NAME,
      };
